export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.getyusr.com/api/v1',
  adminApiBaseUrl: 'https://dev.api.getyusr.com/admin/api/v1',
  appVersion: 'v0.0.5',
  name: 'development',
  sentry: {
    tracesSampleRate: 1.0,
    breadcrumbSampleRate: 1.0,
  },
  moyasar: {
    publishableKey: 'pk_test_tN3nrEwexoFUayZ7eUuA3vt4TrViupfNGxRHsz62',
    apiUrl: 'https://api.moyasar.com/v1'
  }
};
